/* istanbul ignore next function */
export function getUrlHostParts() {
  return window.location.hostname.split(".");
}

export function isProd() {
  const hostParts = getUrlHostParts();
  return hostParts.length < 4 && hostParts[1] === "collectivehealth" && hostParts[2] === "com";
}

export function isLocal() {
  const hostParts = getUrlHostParts();
  return hostParts.length > 3 && hostParts[1] === "local";
}
